const fr = {
  today: "Matchs du Jour",
  live: "EN DIRECT",
  upcoming: "À Venir",
  stats: "Statistiques",
  noLive: "Aucun match en direct",
  clickForStats: "Cliquez pour les stats complètes",
  viewOdds: "Voir les Cotes →",
  headToHead: "Face à Face",
  form: "Forme Actuelle",
  goalStats: "Stats des Buts",
  leagueTable: "Classement",
  injuries: "Blessures et Suspensions",
  outcome: "Résultat Probable",
  homeWin: "Victoire Domicile",
  draw: "Nul",
  awayWin: "Victoire Extérieur",
  confidence: "Confiance",
  viewing: "personnes regardent",
  subscribe: "Recevez des Analyses Gratuites",
  subscribeDesc: "Chaque vendredi — Top 5 matchs avec stats.",
  yourEmail: "Votre email",
  subscribe_btn: "S'abonner Gratuitement",
  worldCup: "Coupe du Monde FIFA 2026",
  daysAway: "jours restants",
  viewQualifiers: "Voir les Qualifications",
  featuredMatches: "🔥 Grands Matchs",
  favourite: "Équipes Favorites",
  addFav: "Ajouter aux favoris",
  removeFav: "Retirer des favoris",
  kickoff: "Coup d'envoi",
  stadium: "Stade",
  season: "Aperçu de la Saison",
  loading: "Chargement des matchs...",
  avgScored: "Moy. Buts Marqués",
  avgConceded: "Moy. Buts Encaissés",
};
export default fr;